export const PreviewResizeObserverIsland = () => import("./../components/PreviewResizeObserver.island").then(module => module.PreviewResizeObserverIsland);
